import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { NavbarComponent } from './navbar.component';

@NgModule({
  imports: [RouterModule, CommonModule, MatButtonModule, TranslateModule],
  declarations: [NavbarComponent],
  exports: [NavbarComponent],
})

export class NavbarModule {
}
